import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="problem" ref={ref} className="w-full bg-white py-8 md:py-16 px-4" data-id="element-308">
      <div className="max-w-4xl mx-auto" data-id="element-309">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-310">
          <p className="text-xl md:text-2xl lg:text-3xl font-serif italic text-navy mb-4 md:mb-6 leading-relaxed" data-id="element-311">
            There's a moment that happens every Sunday evening.
          </p>

          <div className="space-y-4 md:space-y-6 text-base md:text-lg leading-relaxed" data-id="element-312">
            <p data-id="element-313">
              The rest of the world is winding down. Maybe you're with your
              family. Maybe you're watching something. But somewhere underneath
              all of it — quietly, persistently — a thought keeps surfacing.
            </p>

            <p className="text-lg md:text-xl font-semibold text-navy italic" data-id="element-314">
              "What am I actually teaching tomorrow?"
            </p>

            <p data-id="element-315">And just like that, the weekend is over.</p>

            <p data-id="element-316">
              You open a tab. You search for activities. You find something that
              looks promising, spend forty minutes reading through it, and
              realize it's for the wrong grade level, needs materials you don't
              have, and won't land with your students anyway.
            </p>

            <p className="text-lg md:text-xl font-bold text-navy pt-4" data-id="element-317">
              This is not a talent problem. This is a systems problem.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-8 md:mt-12 pt-8 md:pt-12 border-t-2 border-gold" data-id="element-318">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-navy mb-4 md:mb-6" data-id="element-319">
            Here's what nobody tells you before you become a music teacher.
          </h2>

          <div className="space-y-4 md:space-y-6 text-base md:text-lg leading-relaxed" data-id="element-320">
            <p data-id="element-321">
              You pictured the teaching. You pictured walking into a room and
              turning students on to something that would follow them for the
              rest of their lives.
            </p>

            <p className="font-semibold text-navy" data-id="element-322">
              Nobody warned you about the planning.
            </p>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {
            opacity: 0,
            scale: 0.95
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="my-6 md:my-8" data-id="element-323">
              <img src="https://cdn.magicpatterns.com/uploads/9UgKngrbKLWtCY2SSEM6pv/PaMIp4S0SHZxUL7gtBSV9.png" alt="Music teacher teaching students in classroom with musical notation on board" className="w-full rounded-lg shadow-xl" data-id="element-324" />
            </motion.div>

            <div className="bg-cream p-4 md:p-6 rounded-lg my-4 md:my-6 border-l-4 border-gold" data-id="element-325">
              <p className="text-base md:text-lg leading-relaxed" data-id="element-326">
                <strong className="text-navy" data-id="element-327">
                  59% of public school teachers experience frequent job-related
                  stress
                </strong>
                , with teachers working an average of nine hours per week more
                than similar working adults.
              </p>
            </div>

            <p className="text-lg md:text-xl font-bold text-navy" data-id="element-328">
              This is a crisis. And it starts — and ends — with the system
              you're working inside.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-8 md:mt-12 flex justify-center" data-id="element-329">
          <img src="https://cdn.magicpatterns.com/uploads/aPxmD3TazxoQn2Tfg3YmWt/IMG-M02.png" alt="Music teacher's desk with lesson plans" className="w-full max-w-md md:max-w-2xl rounded-lg shadow-xl" data-id="element-330" />
        </motion.div>
      </div>
    </section>;
}